import { store } from '../../../index'

import { fetchAssignedUsersSuccess } from '../../assignedUsers'
import { fetchUsersSuccess } from '../../cv_users'
import { success as userUpdate } from '../user'
import { updateUser as cvSearchUpdateUser } from '../../cv_search'
import { composerAct } from '../..'
import poolLists from '../../../poolLists/actions'

const { dispatch, getState } = store

/**
 * Update conversation status
 * @param {object} event
 * @param {object} event.data
 * @param {object} event.data.subject subject updated
 * @param {object} event.data.message conversation updated
 *
 * @returns {boolean}
 */
export const updateUserStatus = (event) => {
  const currentState = getState()

  const { message: updateUser, subject } = event.data
  const operator = currentState.user
  const users = currentState.cv_users?.users || []
  const usersAssigned = currentState.assignedUsers?.users|| []
  const tabs = currentState.tabs
  const searchUsers = currentState.cv_search?.search_users

  if (operator.onlyAssignedConversations && !updateUser.assignedTo?.includes(operator._id)) {
    return true
  }

  const index = users.findIndex((user) => user.id === updateUser.id)

  // Remove user from users list
  if (index !== -1) users.splice(index, 1)

  // Update user assigned
  if (updateUser.assignedTo.length) {
    dispatch(fetchAssignedUsersSuccess([updateUser].concat(usersAssigned)))
  }

  if (!operator.onlyAssignedConversations) {
    // Update users list
    dispatch(fetchUsersSuccess({ users: [updateUser].concat(users) }))
  }

  //If user tab is open, update it's information
  if (tabs.users?.some(e => e?.id === updateUser.id)) {
    dispatch(userUpdate(updateUser))
  }

  // update users for search
  const userInCvSearch = searchUsers.find(el => el.id === updateUser.id)
  if(userInCvSearch) dispatch(cvSearchUpdateUser(updateUser))

  if (subject?.state) {
    dispatch(composerAct.updateStatusChatmail(subject))
  } else {
    if (updateUser?.channels?.find(it => it.provider === 'chatmail') && updateUser?.state === 'removed') {
      dispatch(composerAct.updateStatusChatmail({ state: null }))
    }
  }

  if (updateUser.isInList) {
    dispatch(poolLists.event({ onlyListIsAvailable: true }))
  }

  return true
}

/**
 * Update conversation order
 * @param {object} event
 * @param {object} event.data
 * @param {object} event.data.message conversation updated
 *
 * @returns {boolean}
 */
export const updateUserOrder = (event) => {
  const currentState = getState()

  const { message: updateUser } = event.data
  const operator = currentState.user
  const users = currentState.cv_users?.users || []
  const usersAssigned = currentState.assignedUsers?.users|| []

  if (operator.onlyAssignedConversations && !updateUser.assignedTo?.includes(operator._id)) {
    return true
  }

  let indexUserFound = -1
  const userFound = users.find((user, idx) => {
    if (user.id === updateUser.id) {
      indexUserFound = idx
      return true
    }

    return false
  })

  let userToInsert = {}
  if (indexUserFound !== -1) {
    userToInsert = {
      ...userFound
    }

    users.splice(indexUserFound, 1)

    const {
      outbound, lastMessageSentAt, lastMsgType, outboundAt,
      updatedAt, notInPool, isRead, lastMessageDate, channelRemove
    } = updateUser

    const isUpdated = updatedAt && indexUserFound.updatedAt
      ? new Date(updatedAt) > new Date(indexUserFound.updatedAt)
      : false

    if (lastMessageSentAt) userToInsert.lastMessageSentAt = lastMessageSentAt
    if (lastMessageDate) userToInsert.lastMessageDate = lastMessageDate
    if (lastMsgType) userToInsert.lastMsgType = lastMsgType
    if (typeof channelRemove === 'boolean') userToInsert.channelRemove = channelRemove
    if (typeof outbound === 'boolean') userToInsert.outbound = outbound
    if (outboundAt) userToInsert.outboundAt = outboundAt
    if (isUpdated && typeof notInPool === 'boolean') userToInsert.notInPool = notInPool
    if (isUpdated && typeof isRead === 'boolean') userToInsert.isRead = isRead
  } else {
    userToInsert = updateUser
  }

  // update user list
  if (updateUser.assignedTo.length) {
    dispatch(fetchAssignedUsersSuccess([userToInsert].concat(usersAssigned)))
  }

  if (!operator.onlyAssignedConversations) {
    dispatch(fetchUsersSuccess({ users: [userToInsert].concat(users) }))
  }

  return true
}

